import * as React from 'react';
import { useLogger } from '@ids/appshell';
import { Maybe } from '@ids/types/utility';

export interface ErrorBoundaryState {
    hasError: boolean;
}

export interface ErrorBoundaryProps {
    boundaryName: string;
    fallbackComponent?: Maybe<React.ReactElement>;
}

const ErrorBoundaryLogger = ({ name, children }: React.PropsWithChildren<{ name: string }>) => {
    const logger = useLogger();

    logger.error(`[IDS Error Boundary]: There was an error inside the ${name}.`);

    return <React.Fragment>{children}</React.Fragment>;
};

class ErrorBoundary extends React.Component<ErrorBoundaryProps, ErrorBoundaryState> {
    public constructor(props: ErrorBoundaryProps) {
        super(props);
        this.state = { hasError: false };
    }

    public static getDerivedStateFromError() {
        return { hasError: true };
    }

    public render() {
        if (this.state.hasError) {
            const { fallbackComponent = null } = this.props;

            return <ErrorBoundaryLogger name={this.props.boundaryName}>{fallbackComponent}</ErrorBoundaryLogger>;
        }

        return this.props.children;
    }
}

export { ErrorBoundary as default, ErrorBoundaryLogger };
